import React from 'react';

function TutorialHeader() {
  return (
    <>
      <h1 className="text-primary h2 fw-bold mt-5 mt-lg-0">Let’s get you ready!</h1>
      <p className="fs-4">Here’s everything you need to know.</p>
    </>
  );
}

export default TutorialHeader;
